// extracted by mini-css-extract-plugin
export default {"addRowBtn":"components_addRowBtn__R6sWT","rowBtnInner":"components_rowBtnInner__-5T2-"};